export interface PlaceDetails {
  name: string;
  formatted_address?: string;
  rating?: number;
  user_ratings_total?: number;
  formatted_phone_number?: string;
  international_phone_number?: string;
  website?: string;
  url?: string;
  price_level?: number;
  types?: string[];
  business_status?: string;
  editorial_summary?: { overview?: string };
  opening_hours?: {
    open_now?: boolean;
    weekday_text?: string[];
    isOpen?: () => boolean;
  };
  photos?: Array<{ getUrl: (options: { maxWidth?: number; maxHeight?: number }) => string }>;
  geometry?: { location?: { lat: () => number; lng: () => number } };
}

export const PLACE_DETAIL_FIELDS = [
  'name',
  'formatted_address',
  'rating',
  'user_ratings_total',
  'formatted_phone_number',
  'international_phone_number',
  'website',
  'url',
  'opening_hours',
  'current_opening_hours',
  'photos',
  'geometry',
  'price_level',
  'types',
  'business_status',
  'editorial_summary',
];

export const priceLevelLabels = ['Free', '$', '$$', '$$$', '$$$$'];

export const formatPlaceType = (type: string) =>
  type
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const getOpenStatus = (place: PlaceDetails) => {
  if (place.opening_hours?.open_now !== undefined) {
    return place.opening_hours.open_now;
  }
  if (typeof place.opening_hours?.isOpen === 'function') {
    return place.opening_hours.isOpen();
  }
  return null;
};

export const normalizePlaceDetails = (
  place: PlaceDetails & { current_opening_hours?: PlaceDetails['opening_hours'] }
): PlaceDetails => ({
  ...place,
  opening_hours: place.current_opening_hours || place.opening_hours,
});
